// CSS-only Greek symbol spinner — cycles Δ → Γ → Θ → ν → ρ
// Animation classes ov-g1..ov-g5 defined in index.css

export default function GreekSpinner({ className = '' }) {
  return (
    <div
      className={`relative inline-flex items-center justify-center w-8 h-8 font-mono text-xl text-primary-500 dark:text-primary-400 ${className}`}
      aria-label="Loading"
      role="status"
    >
      <span className="absolute inset-0 flex items-center justify-center ov-g1">Δ</span>
      <span className="absolute inset-0 flex items-center justify-center ov-g2">Γ</span>
      <span className="absolute inset-0 flex items-center justify-center ov-g3">Θ</span>
      <span className="absolute inset-0 flex items-center justify-center ov-g4">ν</span>
      <span className="absolute inset-0 flex items-center justify-center ov-g5">ρ</span>
    </div>
  );
}
